import React, { useEffect } from "react";

import Sidebar from "Parts/Sidebar";
import Title from "Parts/Title";

import formatThousand from "helpers/formatThousand";
import formatDate from "helpers/formatDate";

export default function Transaksi() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const items = [
    {
      id: 1,
      name: "Graphic Designer 01",
      thumbnail: "https://media.bwamicro.com/images/1593528041154.jpg",
      type: "free",
      price: 0,
      level: "beginner",
      date: "2020-09-08 20:10:33",
    },
    {
      id: 3,
      name: "Good Negotiation",
      thumbnail: "https://media.bwamicro.com/images/1593625117490.jpg",
      type: "premium",
      price: 400000,
      level: "beginner",
      date: "2020-10-09 20:10:04",
    },
  ];
  return (
    <div className="flex">
      <Title title="Transaksi"></Title>
      <Sidebar></Sidebar>
      <main className="flex-1">
        <div className="px-16">
          <section className="flex flex-col mt-8">
            <h1 className="text-4xl text-gray-900 font-medium">
              DAFTAR TRANSAKSI
            </h1>
            <p className="text-lg text-gray-600">
              Tabungan yang sudah kamu kumpulkan sejauh ini.
            </p>
          </section>
          <section className="flex flex-col mt-8">
            {items?.length > 0
              ? items?.map((item) => {
                  return (
                    <div
                      key={item.id}
                      className="flex justify-start items-center -mx-4 mt-5"
                    >
                      <div className="w-auto px-4" style={{ width: 150 }}>
                        <img
                          src={item?.thumbnail ?? ""}
                          alt={item?.name ?? "Nama Kelas"}
                        />
                      </div>
                      <div className="w-3/12 px-4">
                        <h6 className="text-gray-900">{item?.name ?? ""}</h6>
                        <p className="text-gray-600">{item?.level ?? ""}</p>
                      </div>
                      <div className="w-3/12 px-4">
                        {item?.type === "free" ? (
                          <h6 className="text-gray-900 font-bold">FREE</h6>
                        ) : (
                          <div>
                            <h6 className="text-gray-900 uppercase font-bold">
                              {item?.type ?? ""}
                            </h6>
                            <p className="text-gray-800">
                              {`Rp. ${formatThousand(item.price)}` ?? ""}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="w-3/12 px-4">
                        <h6 className="text-gray-900">
                          {item?.date ? formatDate(item?.date) : "-"}
                        </h6>
                      </div>
                      <div className="w-auto px-4">
                        <a href={`/kelas/${item?.id}` ?? ""}>
                          <button className="bg-gray-500 hover:bg-gray-300 py-3 px-6 mt-4 transition-all duration-200  focus:outline-none text-white">
                            Lihat Kelas
                          </button>
                        </a>
                      </div>
                    </div>
                  );
                })
              : "Masih kosong nih"}
          </section>
        </div>
      </main>
    </div>
  );
}
